import {UI} from "../../stem-core/ui/UIBase";
import {MessageElement} from "../../blinkpay/widget/ui/MessageElement.jsx";

export function BlinkMakeText(text, options) {
    return <MessageElement message={text} {...options} />;
}
